import { Component } from "react";

import Modal from "./Modal";
import Spinner from "../Utils/Spinner";

class ModalLoader extends Component {
  render() {
    return (
      <Modal className="modal-loader">
        <Spinner className="modal-loading-spinner" />
      </Modal>
    );
  }
}

export default ModalLoader;
